import { Box } from '@mui/material';

import { CompactSchoolLogo } from 'features/CompactSchoolLogo';
import { Breadcrumbs } from 'layout/MainLayout/components/Header/components/components/Breadcrumbs';
import { LogoutButton } from 'layout/MainLayout/components/Header/components/components/LogoutButton';
import { RightContentSection } from 'layout/MainLayout/components/Header/components/components/RightContentSection';
import { RoleIndicator } from 'layout/MainLayout/components/Header/components/components/RoleIndicator';
import { CLOSED_DRAWER_WIDTH } from 'layout/MainLayout/components/Sidebar/constants';
import { LogoLink } from 'shared/components/LogoLink';

import { AppBarWrapper } from './components/AppBarWrapper';
import { MenuButton } from './components/MenuButton';
import { SubHeader } from './components/SubHeader';
import { ToolbarWrapper } from './components/ToolbarWrapper';
import { HEADER_MOBILE_TEST_ID } from './constants';

import type { FC } from 'react';

interface HeaderMobileProps {
  onLogout(): void;
  toggleSidebar(): void;
}

export const HeaderMobile: FC<HeaderMobileProps> = ({
  onLogout,
  toggleSidebar,
}) => (
  <Box position="static" data-testid={HEADER_MOBILE_TEST_ID}>
    <AppBarWrapper position="static">
      <ToolbarWrapper>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <LogoLink sx={{ maxWidth: CLOSED_DRAWER_WIDTH }}>
            <CompactSchoolLogo />
          </LogoLink>
          <MenuButton onClick={toggleSidebar} />
        </Box>
        <RightContentSection>
          <RoleIndicator />
          <LogoutButton onClick={onLogout} />
        </RightContentSection>
      </ToolbarWrapper>
    </AppBarWrapper>
    <SubHeader>
      <Breadcrumbs />
    </SubHeader>
  </Box>
);
